<script setup>
import { computed } from 'vue'
import { useProfileStore } from '@/stores/profile'
import { useEcusStore } from '@/stores/ecus'
import checkArrayIncludes from '@/helpers/checkArrayIncludes'

const props = defineProps({
    uuid: {
        type: String,
        required: true
    },
    ecusList: {
        type: Object,
        required: true
    }
})

const profileStore  = useProfileStore()
const ecusStore     = useEcusStore()

const profile       = computed(() => profileStore.profile)
const ecusProcess   = computed(() => ecusStore.ecusProcess)

// Исключаем блок GNSS общего списка и сортируем по алфавиту
const ecusListToRenderSorted = computed(() => {
    let ecusSorted = {}
    Object
        .keys(props.ecusList)
        .sort()
        .forEach( val => ecusSorted[val] = props.ecusList[val] )
    delete ecusSorted['GNSS']
    return ecusSorted
})

// Блок GNSS
const ecuGNSS = computed(() => props.ecusList['GNSS'])

function makeEcuStyles(ecu) {

    let str = ''

    // мелкий шрифт
    if(ecu.info.name.length > 6) {
        str += 'uta-car-ecus-link--small '
    }

    // загрузка блоков
    if(ecusProcess.value) {
        str += 'progress-bar progress-bar-striped progress-bar-animated uta-car-ecus-link--loading '
    }

    // блоки installed: нет ошибок, диагностика менее 30 дней 
    const time = ecu.info.timeStamp * 1000
    const now = Date.now()

    if(time) {

        let diff = (now - time) / 1000 / 60 /60 /24
        if(diff < 30 && ecu.installed && !ecusProcess.value) {
            str += 'uta-car-ecus-link--active '
            if(ecu.errors.wir && !ecusProcess.value) {
                str += 'uta-car-ecus-link--error '
            }
        } 
    }

    // блоки !installed - стиль по умолчанию
    if(!ecu.installed && !ecusProcess.value) {
        str += 'uta-car-ecus-link--notinstalled '
    }

    return str
}
</script>

<template>
    <div class="uta-car-ecus-tiles">

        <div class="mt-2 mb-5 uta-car-ecus-tiles__block uta-car-ecus-tiles__block--gnss">
            <router-link
                class="uta-car-ecus-link uta-car-ecus-link--tiles-gnss"
                :class="makeEcuStyles(ecuGNSS)"
                :to="'/cars/' + props.uuid + '/ecus/GNSS'"
            >   
                <div class="uta-car-ecus-link__badges" v-if="checkArrayIncludes(profile.attr?.array, ['DIAGNOSTIC', 'SUPER_ADMIN'])">
                    <span
                        v-if="ecuGNSS.errors.passive && !ecusProcess"
                        class="uta-car-ecus-link__badge uta-car-ecus-link__badge--error-passive"
                    >
                        {{ ecuGNSS.errors.passive }}
                    </span>
                    <span
                        v-if="ecuGNSS.errors.active && !ecusProcess"
                        class="uta-car-ecus-link__badge uta-car-ecus-link__badge--error-active"
                    >
                        {{ ecuGNSS.errors.active }}
                    </span>
                </div>

                <span class="uta-car-ecus-tiles__block-name">GNSS</span>
                <img class="uta-car-ecus-tiles__block-icon" src="@/assets/images/icons/icon-gnss.svg" alt="">
                <span class="uta-car-ecus-tiles__block-descr">Global Navigation Satellite System</span>
            </router-link>
        </div>

        <div class="uta-car-ecus-tiles__list">
            <div class="row">

                <div 
                    class="col-8 col-sm-6 col-md-4 col-xxl-3 uta-car-ecus-tiles__block" 
                    v-for="(ecu, index) of ecusListToRenderSorted" 
                    :key="index"
                >
                    <router-link
                        class="has-tooltip uta-car-ecus-link uta-car-ecus-link--tiles" 
                        :class="makeEcuStyles(ecu)"
                        :id="'ecu-' + ecu.info.name"
                        :data-name="ecu.info.fullName"
                        :to="'/cars/' + props.uuid + '/ecus/' + ecu.info.name"
                    >
                        <span class="uta-car-ecus-tiles__block-name">{{ ecu.info.name }}</span>

                        <div class="uta-car-ecus-link__badges">
                            <span
                                v-if="ecu.errors.passive && !ecusProcess"
                                class="uta-car-ecus-link__badge uta-car-ecus-link__badge--error-passive"
                            >
                                {{ ecu.errors.passive }}
                            </span>
                            <span
                                v-if="ecu.errors.active && !ecusProcess"
                                class="uta-car-ecus-link__badge uta-car-ecus-link__badge--error-active"
                            >
                                {{ ecu.errors.active }}
                            </span>
                        </div>

                    </router-link>
                </div>

            </div>
        </div>

    </div>
</template>

<style lang="scss">
@import 'tippy.js/dist/tippy.css';
@import '@/assets/styles/scss/components/car/ecus/ecus-tiles.scss';
</style>
